import { useCallback, useMemo } from "react";
import moment from "moment-timezone";
import { Calendar } from "../../../../ui/calendar";
import { useCompanyWeekStartsOn } from "../../../../../utils/hooks/company";
import { useDateFilters } from "../context/useDateFilters";

function Date() {
    const { mode, from, to, modes, dispatch } = useDateFilters();
    const weekStartsOn = useCompanyWeekStartsOn() as 0 | 1 | 2 | 3 | 4 | 5 | 6;
    const selected = useMemo(() => ({
        from: moment(from).toDate(),
        to: moment(to).toDate(),
    }), [from, to]);

    const { calendarMode, numberOfMonths }: any = useMemo(() => {
        const calendarMode = (["day", "week"].includes(mode) && modes.length === 1) ? "single" : "range";
        const numberOfMonths = (["day", "week"].includes(mode) && modes.length === 1) ? 1 : 2;
        return { calendarMode, numberOfMonths };
    }, [mode, modes.length]);

    const onSelect = useCallback((range: { from?: Date; to?: Date }, selectedDay?: Date) => {
        if (mode === "day") {
            const formattedDate = moment(selectedDay).format("YYYY-MM-DD");
            dispatch({ type: "set-range", payload: { from: formattedDate, to: formattedDate } });
        } else if (mode === "custom") {
            if (range.from && range.to) {
                const from = moment(range.from).format("YYYY-MM-DD");
                const to = moment(range.to).format("YYYY-MM-DD");
                dispatch({ type: "set-range", payload: { from, to } });
            }
        } else {
            const from = moment(selectedDay)
                .startOf(mode as moment.unitOfTime.StartOf)
                .format("YYYY-MM-DD");
            const to = moment(selectedDay)
                .endOf(mode as moment.unitOfTime.StartOf)
                .format("YYYY-MM-DD");
            dispatch({ type: "set-range", payload: { from, to } });
        }
    }, [dispatch, mode]);

    return (
        <div className="tw-flex tw-justify-center tw-p-3">
            <Calendar
                key={from}
                className="tw-bg-popover"
                mode={calendarMode}
                selected={selected}
                onSelect={onSelect}
                numberOfMonths={numberOfMonths}
                weekStartsOn={weekStartsOn}
                disabled={() => false}
                required={true}
                defaultMonth={moment(from).toDate()}
            />
        </div>
    );
}

export default Date;
